
import PropTypes from 'prop-types'
import moment from 'moment'
import { FleetIcon } from 'frame/components'
import { types } from '../../module'

import TableCell from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'
import TableCellView from 'frame/components/table-cell/table-cell'

const Row = ({ item, columns, selected, onSelect, onView }) => {

  const vehicleText = [item.year, item.make, item.model]
    .filter(Boolean)
    .join(' ')

  return (
    <TableRow
      hover
      sx={{
        boxSizing: 'border-box',
        verticalAlign: 'middle',
        height: '30px',
        borderBottom: '5px solid white',
      }}
      selected={selected.indexOf(item.id) !== -1}>
      <TableCell sx={{ bgcolor: 'white', width: '10px', p: 0 }} />
      {columns.thirdPartyNumber && (
        <TableCellView isFirst>
          <FleetIcon fleetName={item.thirdPartyNumber} />
        </TableCellView>
      )}
      {columns.requestDate && (
        <TableCellView>
          {item.requestDate ? moment(item.requestDate).format('DD/MM/YY') : '-'}
        </TableCellView>
      )}
      {columns.agreementNumber && (
        <TableCellView>
          {item.agreementNumber || '-'}
        </TableCellView>
      )}
      {columns.rego && (
        <TableCellView>
          {item.rego || '-'}
        </TableCellView>
      )}
      {columns.make && (
        <TableCellView>
          {vehicleText || '-'}
        </TableCellView>
      )}
      {columns.odometer && (
        <TableCellView>
          {item.odometer || '-'}
        </TableCellView>
      )}

      {columns.requestRucKm && (
        <TableCellView>
          {item.requestRucKm || '-'}
        </TableCellView>
      )}

      {columns.maturityDate && (
        <TableCellView>
          {item.maturityDate ? moment(item.maturityDate).format('DD/MM/YY') : '-'}
        </TableCellView>
      )}

      {columns.controller && (
        <TableCellView>
          {item.controller || '-'}
        </TableCellView>
      )}

      {columns.costCentre && (
        <TableCellView>
          {item.costCentre || '-'}
        </TableCellView>
      )}

      {columns.requestSource && (
        <TableCellView>
          {item.requestSource || '-'}
        </TableCellView>
      )}

      {columns.requestorDriverName && (
        <TableCellView>
          {item.requestorDriverName || '-'}
        </TableCellView>
      )}

      {columns.requestorDriverEmail && (
        <TableCellView>
          {item.requestorDriverEmail || '-'}
        </TableCellView>
      )}
      {Object.values(columns).some(value => value === true) &&
        (<TableCellView isLast></TableCellView>)
      }
    </TableRow>
  )
}

Row.propTypes = {
  item: types.ModelType.isRequired,
  columns: types.ColumnsType.isRequired,
  selected: types.IDListType.isRequired,
  onSelect: PropTypes.func,
  onView: PropTypes.func.isRequired,
}

export default Row
